import { ITariff } from '../store/tariff.slice';

export const getIsActiveOrScheduledProps = (tariffId: string, active: ITariff[], scheduled: ITariff[]) => {
  const foundActive = active.filter((h) => h.id === tariffId);
  const foundScheduled = scheduled.filter((h) => h.id === tariffId);

  const activePlan = foundActive.at(-1);
  const scheduledPlan = foundScheduled.at(-1);

  return {
    active: activePlan ? true : false,
    scheduled: scheduledPlan ? true : false,
    start_end_date:
      activePlan && scheduledPlan && activePlan.id === scheduledPlan.id
        ? scheduledPlan.end_date
          ? new Date(scheduledPlan.end_date)
          : undefined
        : activePlan
          ? activePlan.end_date
            ? new Date(activePlan.end_date)
            : undefined
          : scheduledPlan
            ? scheduledPlan.start_date
              ? new Date(scheduledPlan.start_date)
              : undefined
            : undefined,
  };
};

export const isToolActive = (tool: string, tariff: ITariff[]) => {
  const res = tariff.filter((t) => {
    if (t.tools_data && t.tools_data.some((toolItem) => toolItem.name === tool)) {
      return true;
    }

    return (t.tool_labels || []).includes(tool);
  });

  return res.length > 0;
};

export function getTariffsIfNotInActive(active: ITariff[], current: ITariff[]): ITariff[] {
  // Создаем Set из id элементов массива A для быстрого поиска.
  const setAIds = new Set(active.map((item) => item.id));

  // Фильтруем массив B, оставляя только те элементы, id которых нет в setAIds.
  const elementsNotInA = current.filter((item) => !setAIds.has(item.id));

  return elementsNotInA;
}
